import * as signalR from '@microsoft/signalr';
import { apiList } from "../api/apiList";

// local
// const chatHubUrl = 'https://localhost:5201/RTEvents';

//development
//const chatHubUrl = `${apiList.baseUrl.replace('api/','')}RTEvents`;
const chatHubUrl = `${apiList.baseUrl}messageHub`;

const connection = new signalR.HubConnectionBuilder()
  .withUrl(chatHubUrl)
  .withAutomaticReconnect()
  .build();

connection.start().catch(function (err) {
  return console.error(err.toString());
});

export default connection;
